var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("div", { staticClass: "sicarf-galeria" }, [
        _c("h1", { staticClass: "titulo-sicarf" }, [_vm._v("Galeria")]),
        _c("img", {
          staticClass: "redimensiona",
          attrs: { src: require("@/assets/images/linha.png") }
        })
      ]),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 5 } },
        [
          _c(
            "el-col",
            {
              staticStyle: { "padding-bottom": "4px" },
              attrs: { xs: 24, sm: 8 }
            },
            [
              _c("img", {
                key: 12,
                staticClass: "image",
                attrs: { src: _vm.images[12], loading: "lazy" },
                on: {
                  click: function($event) {
                    _vm.index = 12
                  }
                }
              })
            ]
          ),
          _c(
            "el-col",
            { staticClass: "hidden-xs-only", attrs: { xs: 24, sm: 8 } },
            [
              _c("div", [
                _c("img", {
                  key: 0,
                  staticClass: "image",
                  attrs: { src: _vm.images[0], loading: "lazy" },
                  on: {
                    click: function($event) {
                      _vm.index = 0
                    }
                  }
                }),
                _c("img", {
                  key: 3,
                  staticClass: "image",
                  attrs: { src: _vm.images[3], loading: "lazy" },
                  on: {
                    click: function($event) {
                      _vm.index = 3
                    }
                  }
                })
              ])
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "padding-bottom": "4px" },
              attrs: { xs: 24, sm: 8 }
            },
            [
              _c("img", {
                key: 10,
                staticClass: "image",
                attrs: { src: _vm.images[10], loading: "lazy" },
                on: {
                  click: function($event) {
                    _vm.index = 10
                  }
                }
              })
            ]
          )
        ],
        1
      ),
      _c("vue-gallery-slideshow", {
        attrs: { images: _vm.images, index: _vm.index },
        on: {
          close: function($event) {
            _vm.index = null
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fbc5df3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbc5df3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/home/TheGallery.vue
// module id = null
// module chunks = 